export const fieldCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};
